import React, { useEffect, useState } from 'react';
import { Modal } from '../../../components/modals';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/types';
import {  DeleteCustomComponentResponse } from '../../../api/new-custom-component';
import { successAlert,errorAlert } from '../../../components/toastify/notify-toast';
import { DataSourceHandler, ConnectionAccessDto } from '../../../api/data-source-handler';
import { toggleDataBrowserModal } from '../../../store/datasources';

interface DeleteConnectionModalProps {
    selectedConnectionInfo: { id: number; name: string; sharedWithCount?: number };
    onDeleteConnSuccess: () => void;
}

export const DeleteConnectionModal: React.FC<DeleteConnectionModalProps> = ({ selectedConnectionInfo, onDeleteConnSuccess }) => {
    const dispatch = useDispatch();
    const { deleteConnection: showModal } = useSelector((store: RootState) => store.NewDataSourceReducer.showModal);
    const { envVariables: Env } = useSelector((store:RootState)=> store.AccountReducer);
    const [sharedWithUsers, setSharedWithUsers] = useState<ConnectionAccessDto[]>([]);
    const isShared = !!selectedConnectionInfo.sharedWithCount;

    useEffect(() => {
        if (showModal && isShared && Env?.REACT_APP_PLATFORM_URL) {
            DataSourceHandler.GetConnectionAccessList(
                `${Env.REACT_APP_PLATFORM_URL}/databrowser/api`,
                selectedConnectionInfo.id,
                (res: ConnectionAccessDto[]) => setSharedWithUsers(res || []),
                () => setSharedWithUsers([])
            );
        } else if (!showModal) {
            setSharedWithUsers([]);
        }
    }, [showModal, isShared, selectedConnectionInfo.id, Env?.REACT_APP_PLATFORM_URL]);

    function toggleClose() {
        dispatch(toggleDataBrowserModal('deleteConnection', false));
    }

    function handleConnectionDeleteSuccess(response: any) {
        onDeleteConnSuccess();
        // if (response.success) {
        successAlert(response);
        toggleClose();
        // }
    }

    function handleConnectionDeleteError(error: any) {
        toggleClose();
        errorAlert(error.data??error?.data?.message);
    }

    function handledeleteConnection() {
        DataSourceHandler.DeleteConnection(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, selectedConnectionInfo.id, handleConnectionDeleteSuccess, handleConnectionDeleteError);
    }

    return (
        <Modal
        
            isOpen={showModal}
            toggleClose={toggleClose}
            title={`Delete ${selectedConnectionInfo.name} Connection`}
            className="deleteWorkflowModal"
        >
            {isShared && (
                <>
                    <p className="deleteWorkflowModal__areYouSureMsg">
                        This connection is shared with {selectedConnectionInfo.sharedWithCount} user{selectedConnectionInfo.sharedWithCount === 1 ? '' : 's'}.
                    </p>
                    <p className="deleteWorkflowModal__areYouSureMsg">Deleting it will remove access for:</p>
                    <ul className="deleteWorkflowModal__sharedUsersList">
                        {sharedWithUsers.map((user) => (
                            <li key={user.id}>{user.userId}</li>
                        ))}
                    </ul>
                </>
            )}
            <p className="deleteWorkflowModal__areYouSureMsg">Are you sure you want to delete the selected connection?  </p>
            <p className="deleteWorkflowModal__warningMsg">Warning: You can&apos;t undo this action!</p>
            <div className="modalBtns__box">
                <button
                    id={'Workfflow_deletemodal_btn'}
                    className="btn-md btn-yellow"
                    onClick={handledeleteConnection}
                    type="submit"
                >
                    {isShared ? 'Delete Anyway' : 'Yes'}
                </button>
                <button
                    id={'Workfflow_deletemodal_cancelbtn'}
                    className="btn-md btn-cancel"
                    type="button"
                    onClick={toggleClose}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};